import { forwardRef, useEffect } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  Box,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import FilePondInput from "../../../../helpers/FilePondInput";
import {
  JCategories,
  resetForm,
  setDialog,
} from "../../../../app/slices/jomla/categorySlice";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const JCategoriesForm = () => {
  const _JCategories = useSelector((state) => state.JCategories.JCategory);
  const _SearchBody = useSelector((state) => state.JCategories.searchBody);
  // const _provinces = useSelector((state) => state.provinces.provinces.data);

  const isAdd = _JCategories.form.id ? false : true;
  const { control, reset, handleSubmit } = useForm({
    defaultValues: _JCategories.form,
  });

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("id", data.id);
    if (!isAdd) formData.append("_method", "PUT");
    formData.append("name", data.name);
    formData.append("sequence", data.sequence);
    if (data.logo && data.logo[0].name) formData.append("logo", data.logo[0]);
    if (isAdd) {
      dispatch(JCategories.create(formData, _SearchBody));
    } else {
      dispatch(JCategories.update(data.id, formData, _SearchBody));
    }
  };
  useEffect(() => {
    reset({ ..._JCategories.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_JCategories.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    // <Typography>form test</Typography>
    <Dialog
      open={_JCategories.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      onClose={() => {
        handleDialog();
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          {isAdd ? "أضافة " : "تعديل "}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label=" الاسم"
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Controller
                name="sequence"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="التسلسل"
                    type="number"
                    fullWidth
                    inputProps={{ min: 0 }}
                    {...field}
                  />
                )}
              />
            </Grid>
            {/* <Grid item xs={12} md={12}>
              <Controller
                name="province_ids"
                control={control}
                render={({ field }) => (
                  <SelectProvince
                    multiple
                    onChange={(e, newValue) => {
                      var ids = newValue.map((x) => x.id);
                      setValue("province_ids", newValue ? ids : []);
                    }}
                    value={_provinces?.filter((x) =>
                      field.value?.includes(x.id) ? field.value : null
                    )}
                  />
                )}
              />
            </Grid> */}
            <Grid item xs={12} md={12} display="flex" justifyContent="center">
              <Box
                component="img"
                src={_JCategories.form.logo}
                width={200}
                sx={{ objectFit: "contain" }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Controller
                name="logo"
                control={control}
                render={({ field }) => (
                  <Box>
                    <FilePondInput field={field} required={false} />
                  </Box>
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Button type="submit" variant="contained" color="primary">
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default JCategoriesForm;
